import { StpAbosAccount } from '../StpAbosAccount';
import { CurrencyPair } from '../CurrencyPair';

export class StpTradePreload {
  accounts: Array<StpAbosAccount>;
  currencyPairs: Array<CurrencyPair>;
}
